// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fnlfrdinxtwkhzbmyawv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZubGZyZGlueHR3a2h6Ym15YXd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc3OTE1MDgsImV4cCI6MjA1MzM2NzUwOH0.tm49bNkTr2x0Q9esdnfcv2y-gpylp18b2w2GC0oEm7w";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);